function getNumber(value: string | number | undefined | null): number | undefined {
  // if value is undefined or null, return early
  if (value === undefined || value === null || value === "") {
    return undefined
  }

  // convert to number
  return Number.isNaN(Number(value)) ? undefined : Number(value)
}

export { getNumber }
